import BaseObject from '../../../base/base_object';
import HybridSerialProvider from '../../hybrid/features/serial/providers/provider';
import * as SerialConst from '../../hybrid/features/serial/serial_const';
import Device from '../../../utils/device/device';
import Event from '../../../utils/event';
import {SYSTEM_EVENTS} from '../../../events/events';

/**
 *
 *
 *
 */
class Serial extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'Serial';

    _currentProvider = null;


    /**
     *
     * @param params
     */
    init(params) {

        this._currentProvider = HybridSerialProvider.create(params).getCurrentProvider(SerialConst.SERIAL_PROVIDER.APP_FLYER, params);
        this._subscribe();
    }


    _subscribe() {
        Event.on(SYSTEM_EVENTS.ON_INIT_COMPLETE, () => {
            this.getSerialData();
        });
    }


    /**
     * @param json
     * @returns merge json with hybrid params
     * @public
     */
    getSerialData(marketingData, GNWPRequestModel){

        if (Device.hybrid.inCasino) {
            return this._currentProvider.getSerialData(marketingData, GNWPRequestModel);
        }

        return Promise.resolve(marketingData);
    }
}
export default Serial;
